module.exports = __webpack_public_path__ + "static/media/mascot01.39ef2e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/mascot01.png
// module id = 178
// module chunks = 0